// src/redux/reducer/dashboardSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type FilterState = {
  company: number;
  department: number;
  branch: number;
  financial_year:string;
};

const initialState: FilterState = {
  company: 0,
  department: 0,
  branch: 0,
  financial_year: ''
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterState>) => {
      return { ...state, ...action.payload };
    },
    resetFilters: () => initialState,
  },
});

export const { setFilters, resetFilters } = dashboardSlice.actions;
export default dashboardSlice.reducer;
